import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { PuffLoader } from "react-spinners";
import Header from "./Layouts/Header";
import Footer from "./Layouts/Footer";
import Home from "./Screens/Home/Home";
import About from "./Screens/About";
import OtherCourses from "./Screens/OtherCourses";
import Teams from "./Screens/Peoples/Teams";
import ContactUs from "./Screens/ContactUs";
import Threes from "./Screens/Threes";
import Blogs from "./Screens/Blogs";
import Memories from "./Screens/Memories"
import Product from "./Screens/Product";
import Services from "./Screens/Services";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 750);
  }, []);

  if (loading) {
    return (
      <div className="flex min-h-screen justify-center items-center bg-slate-700 relative ">
        <PuffLoader color="#36d7b7" size={150} />
        <h4 className="absolute text-white font-Argent">technoweit</h4>
      </div>
    );
  }

  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/other-courses" element={<OtherCourses />} />
        <Route path="/teams" element={<Teams />} />
        <Route path="/product" element={<Product />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/blog" element={<Blogs />} />
        <Route path="/memories" element={<Memories />} />

      </Routes>


      <Footer />
    </Router>
  );
}

export default App;
